import type { IAuthRepository } from '../domain/repositories/IAuthRepository';
import { saveAuthSession } from '../domain/entities/AuthSession';
import type { AuthSession } from '../domain/entities/AuthSession';

export async function loginUseCase(
  repo: IAuthRepository,
  email: string,
  password: string,
): Promise<AuthSession> {
  const session = await repo.login(email, password);
  saveAuthSession(session);
  return session;
}
